import { has, reduce } from 'lodash';

import { roleToNameInCentral } from 'components/pages/study/StudyDetails/SiteDetails/AddOrEditPersonnelModal/AddRole/roleUtils';

export function prepareAddRoleRequest(addRoleForm) {
  return {
    role: roleToNameInCentral[addRoleForm.role],
    groupAssignId: addRoleForm?.groupAssign?.id,
    financeAccess: toFinanceAccessObject(addRoleForm.financeAccess),
    startDate: toUtcDateTime(addRoleForm.startDate, addRoleForm.startTime),
    expireDate: toUtcDateTime(addRoleForm.expireDate, addRoleForm.expireTime)
  };
}

function toUtcDateTime(date, time) {
  if (date && time) {
    const momentDateTime = date.clone().set({
      hour: time.get('hour'),
      minute: time.get('minute'),
      second: time.get('second'),
      millisecond: time.get('millisecond')
    });
    return momentDateTime
      .utc()
      .toDate()
      .toISOString();
  }
  return null;
}

function toFinanceAccessObject(financeAccessOptions) {
  const defaultFinanceAccess = {
    patientPaymentAccess: false,
    financeDetailsAccess: false,
    remittanceNotification: false,
    expensesAccess: false
  };
  return reduce(
    financeAccessOptions,
    function(acc, curr) {
      if (has(acc, curr)) {
        acc[curr] = true;
      }
      return acc;
    },
    defaultFinanceAccess
  );
}
